.container {
  margin-top: 10rem;
  width: 74.6rem;

  .left {
    display: flex;
    position: relative;
    flex-direction: row;
    margin-bottom: 16rem;
    .textContainer {
      position: relative;
      height: 21.313rem;
      h4 {
        font-family: 'Poppins', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.5rem;

        color: #9857d3;
      }
      h2 {
        font-family: 'Poppins', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 2.125rem;
        line-height: 3.188rem;
        color: #ccd6f6;
        margin-top: -0.125rem;
      }
    }
    .text {
      display: flex;
      align-items: center;
      overflow: hidden;
      white-space: nowrap;

      font-family: 'Poppins', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 1.125rem;
      line-height: 1.688rem;

      height: 10.313rem;
      width: 41.813rem;
      margin-top: 1.875rem;
      border-radius: 0.938rem;
      padding: 1.25rem;
      background-color: rgba(126, 88, 192, 0.08);
      backdrop-filter: blur(15px);
    }
    .imgContainer {
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
      right: 0px;

      width: 36.43rem;
      height: 21.313rem;
      border-radius: 15px;

      transform: translateX(-4rem);

      padding-top: 3rem;

      background: #2b0b3a;
      z-index: -1;
      img {
        position: absolute;

        left: 3.5rem;

        max-width: calc(100% + 3.5rem);
      }
    }
    .backgroundRadial {
      display: block;
      position: absolute;
      right: 0px;
      z-index: -2;
      width: 35.75rem;
      height: 40.063rem;

      transform: translate(10rem, -10rem);

      background: radial-gradient(
        50% 50% at 50% 50%,
        #763cac 0%,
        rgba(50, 15, 133, 0) 100%
      );
    }
    .clicks {
      position: absolute;
      bottom: 0px;
      margin-left: 1.875rem;
    }
  }
  .right {
    display: flex;
    position: relative;
    flex-direction: row-reverse;
    .textContainer {
      position: relative;
      height: 21.313rem;
      float: right;
      h4 {
        text-align: right;
        font-family: 'Poppins', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.5rem;

        color: #9857d3;
      }
      h2 {
        font-family: 'Poppins', sans-serif;
        font-style: normal;
        text-align: right;
        font-weight: 600;
        font-size: 2.125rem;
        line-height: 3.188rem;
        color: #ccd6f6;
        margin-top: -0.125rem;
      }
    }
    .text {
      display: flex;
      align-items: center;
      overflow: hidden;
      white-space: nowrap;

      font-family: 'Poppins', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 1.125rem;
      line-height: 1.688rem;

      height: 10.313rem;
      width: 41.813rem;
      margin-top: 1.875rem;
      border-radius: 15px;
      padding: 1.25rem;
      background-color: rgba(126, 88, 192, 0.08);
      backdrop-filter: blur(15px);
    }
    .imgContainer {
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
      left: 0px;

      width: 36.43rem;
      height: 21.313rem;
      border-radius: 15px;

      transform: translateX(4rem);

      padding-top: 3rem;

      background: #2b0b3a;
      z-index: -1;
      img {
        position: absolute;

        max-width: calc(100% + 3.5rem);

        right: 3.5rem;
      }
    }
    .backgroundRadial {
      display: block;
      position: absolute;
      left: 0px;
      z-index: -2;
      width: 35.75rem;
      height: 40.063rem;

      transform: translate(-10rem, -10rem);

      background: radial-gradient(
        50% 50% at 50% 50%,
        #763cac 0%,
        rgba(50, 15, 133, 0) 100%
      );
    }
    .clicks {
      position: absolute;
      bottom: 0px;
      right: 1.875rem;
    }
  }
}
